module.exports = __webpack_public_path__ + "img/p2.a6f5eda6.jpg";